import { render, staticRenderFns } from "./TestFailReason.vue?vue&type=template&id=20ecb07c&scoped=true&"
import script from "./TestFailReason.vue?vue&type=script&lang=js&"
export * from "./TestFailReason.vue?vue&type=script&lang=js&"
import style0 from "./TestFailReason.vue?vue&type=style&index=0&id=20ecb07c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ecb07c",
  null
  
)

export default component.exports